<template>
    <div class="home-content">
        <div class="container">
            <div class="home-content-title">
                <h1 class="heading-1">Recherchez par revue</h1>
                <p>Explorez les articles de la revue de votre choix en cliquant sur sa couverture.</p>
            </div>
        </div>
        <div class="home-content--livres">
            <div class="container">
                <div class="livres-items">
                    <div class="livres-items--item" 
                        @click="showRevue(abonnement)" 
                        v-for="abonnement in listePublications" 
                        :key="abonnement.key" 
                        :class="getClass(abonnement)">
                        <img :src="abonnement.cover" :alt="abonnement.numero" v-if="abonnement.cover">
                        <img src="@/assets/images/livres.jpg" alt="" v-else>
                        <div class="text-center">
                            <h3 class="livres-items--heading">{{ abonnement.key }}</h3>
                            <p class="livres-items--desc" v-if="abonnement.isAbonne">Abonné</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// import { toRaw } from 'vue'
import { mapState, mapGetters, mapActions } from 'vuex'

export default {
    name: "listeRevue",
    data() {
        return {
            listePublications: [],
        }
    },
    computed: {
        ...mapState([
            'auth'
        ]),
        ...mapGetters([
            'getAbonnements',
            'getPublications'
        ]),
    },
    methods: { 
        ...mapActions([
            'setOnLoad',
            'setPublications'
        ]),
        showRevue(abonnement) {
            this.$emit('selected-revue', abonnement);
            //if (abonnement.hasAbonne) {
                //this.$emit('selected-revue', abonnement);
            //}
        },
        getClass(abonnement){
            if (abonnement.hasAbonne){
                return 'abonne'
            } else if(abonnement.isAbonne){
                return 'abonne'
            } else {
                return 'abonne'
            }
        }
    },
    watch:{
        getAbonnements: {
            handler(newVal) {
                this.setOnLoad(true);
                if (Array.isArray(newVal) && newVal.length > 0) {
                    this.$api4d.getPublications(this.auth.token).then(({ data }) => {
                        let publications = data.data;
                        // afficher abonné si dans abonnements
                        publications.forEach((element, index) => {
                            let abo = this.getAbonnements.find(f => f.key === element.key);
                            if (abo != undefined) {
                                publications[index]['hasAbonne'] = true;
                                publications[index]['isAbonne'] = abo.inProgress;
                                publications[index]['period'] = abo.period;
                            } else {
                                publications[index]['isAbonne'] = false;
                                if (element.key == "Le Concours médical" || element.key == "Concours pluripro") {
                                    let abo = this.getAbonnements.find(f => f.key === "Le Concours Pluripro");
                                    if (abo != undefined) {
                                        publications[index]['hasAbonne'] = true;
                                        publications[index]['isAbonne'] = abo.inProgress;
                                        publications[index]['period'] = abo.period;
                                    }
                                }
                            }
                        });
                        this.setPublications(publications);
                        this.listePublications = publications
                        this.setOnLoad(false);
                    }).catch((e) => {
                        this.setOnLoad(false);
                        console.log(e)
                    });
                } else {
                    console.log("Aucun abonnement trouvé.");
                }
            },
            immediate: true
        }
    },
    mounted() {
        // get Liste revue
        this.setOnLoad(true);
        if (this.getPublications != null) {
            this.listePublications = this.getPublications
            this.setOnLoad(false);
        }
    }
}
</script>

<style lang="scss" scoped>
    @import "@/scss/helpers/mixins";
    @import "@/scss/helpers/variables";

.home-content {
    &-title {
        max-width: 700px;
        margin: auto;
        padding: 60px 0 40px;
    }

    &--livres{
        overflow: hidden;
        padding: 10px 0 60px;
    }
}

.livres-items {
    display: flex;
    margin: auto;
    overflow-x: scroll;
    white-space: nowrap;
    justify-content: flex-start;

    @include min($lg) {
        overflow: hidden;
        justify-content: center;
    }

    &--item {
        margin: 0 13px;
        text-align: center;
        width: 152px;
        flex: 0 0 152px;
        white-space: normal;


        @include min($lg) {
            width: 134px;
            flex: 0 0 134px;
        }
        

        img {
            height: auto;
            max-width: 100%;
            border-color: #ffffff;
            border-width: 5px;
            border-style: solid;
            border-radius: 10px;
            box-shadow: 0px 3px 5px rgba(40,56,97,0.2);
            margin: 0 0 10px; 
        }

        &.abonne {
            cursor: pointer;
        }

        &.no-abonne {
            img {
                cursor: not-allowed;
                opacity: 0.3;
            }
        }
    }

    &--heading {
        font-family: $campaign;
        font-size: 12px;
        font-weight: $bold;
        line-height: 12px;
        margin: 0;
    }

    &--desc {
        font-size: 10px;
        font-weight: $regular;
        margin: 0;
    }
}
</style>